export const CC_PREFIX = 'rq:cc:';

export function ccKey(type, lv, themeId) {
  return `${CC_PREFIX}${type}:${lv}${themeId ? ':' + themeId : ''}`;
}

export function ccGet(type, lv, themeId) {
  try { const v = localStorage.getItem(ccKey(type, lv, themeId)); return v ? JSON.parse(v) : []; } catch { return []; }
}

export function ccPut(type, lv, themeId, items) {
  try {
    const existing = ccGet(type, lv, themeId);
    const merged = [...existing, ...items];
    localStorage.setItem(ccKey(type, lv, themeId), JSON.stringify(merged.slice(-200)));
  } catch {}
}

export function ccConsume(type, lv, themeId, count) {
  const items = ccGet(type, lv, themeId);
  if (items.length < count) return null;
  const taken = items.slice(0, count);
  const rest = items.slice(count);
  try { localStorage.setItem(ccKey(type, lv, themeId), JSON.stringify(rest)); } catch {}
  return taken;
}

export function ccCount(type, lv, themeId) {
  return ccGet(type, lv, themeId).length;
}
